import { createContext } from 'react';
import { ProjectsRepository } from 'src/projects/ProjectsRepository.ts';

export const ProjectsContext = createContext<() => ProjectsRepository>(() => {
    throw new Error('Projects repository is not initialised');
});
